'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'circle-half';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e110';
var svgPathData = ['M48 256c0 98.3 68.3 180.8 160 202.4l0-404.9C116.3 75.2 48 157.7 48 256z', 'M208 53.6C116.3 75.2 48 157.7 48 256s68.3 180.8 160 202.4l0-404.9zM224.1 2C241.6-.2 256 14.3 256 32l0 448c0 17.7-14.4 32.2-31.9 30C97.8 494.3 0 386.6 0 256S97.8 17.7 224.1 2z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircleHalf = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;